type MessageEventListener = (event: MessageEvent) => void;

let instance: WebViewMessageManager | null = null;

class WebViewMessageManager {
  private listeners: Set<MessageEventListener> = new Set();
  private isListening = false;

  static getInstance(): WebViewMessageManager {
    if (!instance) {
      instance = new WebViewMessageManager();
    }
    return instance;
  }

  addListener(callback: MessageEventListener): () => void {
    this.listeners.add(callback);
    this.setupListenerIfNeeded();

    return () => {
      this.listeners.delete(callback);
      this.cleanupIfNoListeners();
    };
  }

  private setupListenerIfNeeded(): void {
    if (!this.isListening) {
      window.addEventListener('message', this.handleMessage);
      this.isListening = true;
    }
  }

  private cleanupIfNoListeners(): void {
    if (this.listeners.size === 0 && this.isListening) {
      window.removeEventListener('message', this.handleMessage);
      this.isListening = false;
    }
  }

  private handleMessage = (event: MessageEvent): void => {
    this.listeners.forEach(listener => {
      try {
        listener(event);
      } catch (error) {
        console.error('Error in WebView message listener:', error);
      }
    });
  };

  sendMessage(message: string, payload: Record<string, unknown> = {}): void {
    const messageString = JSON.stringify({ message, payload });

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(messageString);
    }
  }
}

export default WebViewMessageManager;
